import React from "react";
import { Input } from "reactstrap";
import "./index.scss";

const SearchBlock = ({ _handler, _keywords }) => {
  return (
    <div className="input-block col-cell">
      <Input
        type="text"
        value={_keywords}
        placeholder="Name, Email"
        onChange={(val) => {
          _handler(val.target.value);
        }}
      />
    </div>
  );
};

export default SearchBlock;
